import React from "react";

const SvgComponent = props => (
  <svg
    viewBox="0 0 275.7 275.7"
    style={{ width: "100%", height: "auto" }}
    {...props}
  >
    <path
      d="M20.219 225.946c14.4 12.857 54.789 10.492 76.938 12.823 22.149 2.331 46.63 9.326 75.773 9.326 46.644 0 85.681 9.326 89.178-2.332 3.497-11.657-12.24-53.04-15.154-63.532-2.915-10.492-36.138-132.894-40.218-145.134-1.96-5.878-19.818-12.823-43.132-11.657-20.408 1.02-54.793-1.329-92.093-.583-29.212.584-53.041-6.412-56.538 13.989-3.497 20.4-1.749 52.458.583 78.104 1.946 21.407.726 105.48 4.663 108.996z"
      fill="none"
      stroke="#000"
      strokeWidth={5}
      strokeDasharray="15.875,5.29166667"
    />
  </svg>
);

export default SvgComponent;



// WEBPACK FOOTER //
// ./images/fragment-manquant.svg